// mailto: follows RFC 6068 (percent-encoding), not form-urlencoding — so spaces
// must be %20, never `+`. URLSearchParams emits `+`, which mail clients render literally.
function encodeParam(name: string, value: string): string {
  return `${name}=${encodeURIComponent(value)}`;
}

export function mailtoHref(email: string, subject?: string, body?: string): string {
  const params = [subject && encodeParam('subject', subject), body && encodeParam('body', body)].filter(Boolean);
  return `mailto:${email}${params.length ? `?${params.join('&')}` : ''}`;
}

export function whatsappMessageHref(baseHref: string, message?: string): string {
  if (!message) {
    return baseHref;
  }
  return `${baseHref}${baseHref.includes('?') ? '&' : '?'}${encodeParam('text', message)}`;
}
